import createReactComponent from '../createReactComponent';
export default createReactComponent('layers-two', 'LayersTwo', [["path",{"d":"m21 14-9 4-9-4m18-4-9 4-9-4 9-4z","key":"svg-0"}]]);